// extracted by mini-css-extract-plugin
export default {"badge":"Badge-module--badge--2277b","shade":"Badge-module--shade--df528","pulse":"Badge-module--pulse--a0cc9"};